// @vendor
const PropTypes = require('prop-types');
const React = require('react');

// @commons
const { OKLink } = require('commonsComponents/OKLink');

const EcommerceKeyShowOrHideNonExpired = (props) => {

    const {
        ecommerceKey,
        linkToBack,
        messageShortNonExpired,
        textBack
    } = props;

    return ( 
        <div className="ecommerce-key-request-view__container">
            <div className="ecommerce-key-request-view__password">
                {ecommerceKey}
            </div>
            <div className="ecommerce-key-request-view__time-message">
                {messageShortNonExpired}
            </div>
            <div className="ecommerce-key-request-view__footer">
                <OKLink modifier="emphasize" to={linkToBack}>
                    {textBack}
                </OKLink>
            </div>
        </div>
    );
}

EcommerceKeyShowOrHideNonExpired.propTypes = {
    ecommerceKey: PropTypes.string.isRequired,
    title: PropTypes.string,
    textBack: PropTypes.string,
    messageShortNonExpired: PropTypes.string,
    linkToBack : PropTypes.string
};

module.exports = EcommerceKeyShowOrHideNonExpired;